import API from '@aws-amplify/api';
import {
  Button,
  ButtonGroup,
  Checkbox,
  Link,
  ResourceItem,
  ResourceList,
  TextStyle
} from '@shopify/polaris';
import _ from 'lodash';
import { useState } from 'react';
import './App.css';
import ConfirmRequest from './ConfirmRequest';


export default function OrderLines(props) {
  const [selected, setSelected] = useState({});
  const [submitting, setSubmitting] = useState();
  const [confirm, setConfirm] = useState();

  let { lines, retryFn, searched, email, doneRequestFn } = props;

  if (_.isEmpty(lines)) {
    if (searched) {
      return (
        <>
          <div style={{ paddingTop: 10, paddingBottom: 10 }}>
            We did not find your order in the tracking system yet. Please try again after a week. Know more about our <Link url="https://hapimanga.com/pages/order-processing-timeline">order timeline</Link>.
          </div>
          
          <Button plain onClick={retryFn}>Click here to find another order</Button>
        </>
      )
    }
    return null;
  }

  let hasRefund = false;
  let hasOutOfStock = false;
  const items = lines.map((line, index) => {
    const orderNoStr = _.get(line, 'order');
    const status = _.get(line, 'status');
    if(_.includes(_.toLower(status), 'refund')) {
      hasRefund = true;
    }
    if(_.includes(_.toLower(status), 'out of stock')) {
      const orderNo = _.replace(orderNoStr, '#', '');
      if(_.toNumber(orderNo) > 2000) {
        hasOutOfStock = true;
      }
    }
    return ({
      ...line,
      id: index,
    });
  });

  function confirmRequestToShip() {
    setConfirm(true);
  }
  function handleCloseConfirm() {
    setConfirm();
  }

  async function handleRequestToShip(shipVia) {
    setConfirm();
    setSubmitting(true);
    const selectedItems = _.values(selected);
    const orderIds = _.chain(selectedItems)
      .map(o => o.order)
      .uniq()
      .value();

    await API.post('requestToShip', '/ship', {
      body: {
        email,
        orderIds,
        shipVia,
        items: selectedItems
      }
    });
    setSubmitting(false);
    doneRequestFn(selectedItems);
  }

  function handleChange(checked, line) {
    const map = { ...selected };
    if (checked) {
      map[line.id] = { ...line };
      setSelected(map);
      return;
    }
    delete map[line.id];
    setSelected(map);
  }

  function getAlternateTool() {
    console.log('xxxx ', hasOutOfStock);
    const buttons = [];
    if (!_.isEmpty(_.keys(selected))) {
      buttons.push(<Button key="ship" primary loading={submitting} onClick={confirmRequestToShip}>Request to ship</Button>);
    }
    if (hasRefund) {
      buttons.push(
        <Button key="refund" url="https://www.cognitoforms.com/HapiMangaStore/refundapplicationform" external={true}>Refund</Button>
      )
    }
    if(hasOutOfStock) {
      buttons.push(
        <Button key="reorder" url="https://www.cognitoforms.com/HapiMangaStore/ReorderForm" external={true}>Willing to wait</Button>
      )
    }
    return _.isEmpty(buttons) ? null : (
      <ButtonGroup>
        {buttons}  
      </ButtonGroup>
    );
  }

  return (
    <div>

      <Button plain onClick={retryFn}>Search again</Button>

      <ResourceList
        items={items}
        showHeader={true}
        totalItemsCount={lines.length}
        alternateTool={getAlternateTool()}
        showing={false}
        renderItem={(line) => {
          const { id, order, item, status, readyToShip } = line;
          return (
            <ResourceItem id={id} verticalAlignment="trailing">
              <TextStyle>
                {order} {item}
              </TextStyle>
              <div>
                <TextStyle variation="subdued">
                  {status}
                </TextStyle>
              </div>
              {readyToShip === 'Yes' && (
                <Checkbox
                  label="Request to ship now"
                  checked={selected[id]}
                  onChange={(checked) =>
                    handleChange(checked, line)
                  }
                />
              )}
            </ResourceItem>
          );
        }}
      />

      {confirm && (
        <ConfirmRequest
          selected={selected}
          open={confirm}
          onClose={handleCloseConfirm}
          onSubmit={handleRequestToShip}
        />
      )}

    </div>
  );
}
